import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zitadel = defineConnector({
  identifier: "zitadel",
  name: "ZITADEL",
  tagLine: "Identity management platform",
  logo,
  protocol: "http",
  tags: ["identity", "security"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.zitadel\\.cloud/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your ZITADEL console, navigate to **Users > Service Users**, create a service user, and generate a personal access token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "ZITADEL host",
          placeholder: "my-org.zitadel.cloud",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/auth/v1/users/me`,
  },
});
